{
  "edit": {
    "name": "Название *",
    "type": "Тип (INT / EXT)",
    "typeShort": "Тип",
    "typeUnset": "— не указан —",
    "typeInt": "INT (интерьер)",
    "typeExt": "EXT (экстерьер)",
    "typeBoth": "INT/EXT (и то, и другое)"
  },
  "variantEdit": {
    "name": "Название (необязательно — подставится из времени/погоды)",
    "namePlaceholder": "Утро, дождь, после ремонта…",
    "timeOfDay": "Время суток",
    "timePlaceholder": "утро, день, вечер, ночь",
    "weather": "Погода",
    "weatherPlaceholder": "ясно, дождь, туман…",
    "notes": "Заметки (дополнительные нюансы освещения/атмосферы — попадут в промпт варианта)",
    "fidelityLabel": "Степень сохранения исходной картинки",
    "fidelityReset": "сбросить",
    "fidelityDefault": "по умолчанию",
    "fidelityHint": "1.0 — минимальные изменения (только освещение), 0.0 — максимальная свобода (другой ракурс/масштаб). Пусто — значение из настроек проекта."
  },
  "correction": {
    "title": "Корректировка референса локации",
    "hint": "Опишите что нужно изменить — на основе текущего изображения будет сгенерирована новая версия",
    "placeholder": "Например: сделай стены кирпичными, добавь окно справа, убери дверь на заднем плане...",
    "submitting": "Отправка…",
    "generate": "Сгенерировать",
    "presets": {
      "moreSpacious": "Просторнее"
    }
  },
  "promptPreview": {
    "title": "Промпт референса",
    "variantSuffix": " · вариант «{{name}}»",
    "building": "Строю промпт…",
    "failed": "Не удалось: {{error}}",
    "systemPrompt": "Системный промпт",
    "userPrompt": "Пользовательский промпт"
  },
  "references": {
    "title": "Версии референса",
    "base": " · базовый",
    "variantSuffix": " · вариант «{{name}}»",
    "hint": "Можно выбрать несколько файлов. Загрузите свою картинку или сгенерируйте новую. Двойной клик по версии — сделать активной.",
    "upload": "Загрузить файл",
    "loading": "Загружаем версии…",
    "empty": "Ещё нет версий. Сгенерируйте референс или загрузите файл.",
    "noPreview": "Нет превью",
    "active": "Активна",
    "uploaded": "Загружено",
    "generated": "Сгенерировано",
    "cleared": "Очищено",
    "correct": "Корректировать",
    "doubleClickActivate": "Двойной клик — сделать активной",
    "delete": "Удалить",
    "deleteConfirm": "Удалить эту версию референса?"
  }
}
